export function formatCurrency(value?:number, sign?:string) {

    if(!value) return '-';

    if(!sign) sign = '$';

    // Check for negative numbers
    const isNegative = value < 0;
    const absoluteValue = Math.abs(value);

    // Define the units and their respective thresholds
    const units = [
        { threshold: 1e12, suffix: 'Tril' },
        { threshold: 1e9, suffix: 'Bln' },
        { threshold: 1e6, suffix: 'Mil' },
        { threshold: 1e3, suffix: 'K' },
    ];

    // Find the appropriate unit to use
    for (let i = 0; i < units.length; i++) {
        const { threshold, suffix } = units[i] as any;

        if (absoluteValue >= threshold) {
            const formattedValue = fixed2IfNotZero(absoluteValue / threshold);
            return `${isNegative ? '-' : ''}${sign} ${formattedValue} ${suffix}`;
        }
    }

    // If value is less than 1,000, return it as is with two decimal places
    return `${isNegative ? '-' : ''}${sign} ${fixed2IfNotZero(absoluteValue)}`;
}

export const formatPercentage = (value?:number) => {
    if(!value) return '-';
    return `${value<0?'':'+'}${value.toFixed(2)}%`;
}

const fixed2IfNotZero = (value:number) => {
    const fixed = value.toFixed(2);
    if(fixed.endsWith('00')) {
        // we need at least 2 decimals
        return value.toPrecision(2);
    }
    return fixed;
}